// Whether the reach neto form holds a date range the back can answer for.
//
// A date input reports what is typed as it is typed: while a client writes
// the year, the browser hands over 0002, 0020 and 0202 before 2026, and each
// of those used to be a request for the channels (back-ratings' handoff of
// 2026-10-20). The back refuses a year before 2000 with a 400, which the form
// showed as "No fue posible cargar los canales y programas" while the client
// was still typing. Its min and max attributes do not stop a typed value.
const DATE = /^(\d{4})-\d{2}-\d{2}$/;
const FIRST_YEAR = 2000;

const complete = (date) => {
  const match = DATE.exec(date || '');
  return Boolean(match) && Number(match[1]) >= FIRST_YEAR;
};

// Both dates whole, from 2000 on, the first not after the second. ISO dates
// compare as strings.
export const isCompleteRange = (lower, upper) =>
  complete(lower) && complete(upper) && lower <= upper;
